<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      location="bottom"
      min-width="auto"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          :model-value="displayValue"
          :label="label"
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="props"
          variant="outlined"
          density="compact"
          hide-details
          color="primary"
          :clearable="clearable"
          @click:clear="clearValue"
        ></v-text-field>
      </template>

      <v-locale-provider locale="en">
        <v-card elevation="4" class="d-inline-block rounded-lg">
          <v-date-picker
            :model-value="pickerAnchor"
            view-mode="months"
            hide-header
            color="primary"
            elevation="0"
            @update:year="onYearUpdate"
            @update:month="onMonthUpdate"
          ></v-date-picker>
        </v-card>
      </v-locale-provider>
    </v-menu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import dayjs from "dayjs";

export default defineComponent({
  name: "MonthPicker",

  props: {
    label: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, null],
      default: "",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:modelValue"],

  data() {
    return {
      menu: false,
      pickerYear: dayjs().year(),
    };
  },

  computed: {
    displayValue(): string {
      if (!this.modelValue) {
        return "";
      }
      const parsed = dayjs(`${this.modelValue}-01`);
      return parsed.isValid() ? parsed.format("MMMM YYYY") : "";
    },
    pickerAnchor(): Date | undefined {
      if (!this.modelValue) {
        return undefined;
      }
      const parsed = dayjs(`${this.modelValue}-01`);
      return parsed.isValid() ? parsed.toDate() : undefined;
    },
  },

  watch: {
    menu(isOpen: boolean) {
      if (isOpen) {
        if (this.modelValue) {
          const parsed = dayjs(`${this.modelValue}-01`);
          if (parsed.isValid()) {
            this.pickerYear = parsed.year();
          }
        } else {
          this.pickerYear = dayjs().year();
        }
      }
    },
  },

  methods: {
    onYearUpdate(year: number) {
      this.pickerYear = year;
    },
    onMonthUpdate(month: number) {
      const year = this.pickerYear ?? dayjs().year();
      const value = `${year}-${String(month + 1).padStart(2, "0")}`;
      this.$emit("update:modelValue", value);
      this.menu = false;
    },
    clearValue() {
      this.$emit("update:modelValue", "");
    },
  },
});
</script>
